import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { DEFAULT_LOCALE } from '../utils/i18n'
import { createUrlBuilders } from './builder'
import { routes } from './registry'

/**
 * Hook that returns URL builders with the current locale baked in.
 * All generated URLs will automatically include the locale prefix.
 *
 * @example
 * const routes = useRoutes()
 * routes.features()                    // '/fr/features' (if on French page)
 * routes.features({ locale: 'en-US' }) // '/features' (override to English)
 * routes.blog.post({ slug: 'hello' })  // '/fr/blog/hello'
 */
export function useRoutes() {
  const intl = useIntl()
  const effectiveLocale = intl.locale ?? DEFAULT_LOCALE

  return useMemo(
    () => createUrlBuilders(routes, effectiveLocale),
    [effectiveLocale]
  )
}
